package com.example.monetix.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.SuspendingTransacterImpl
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Boolean
import kotlin.Long
import kotlin.String

public class FinancingQueries(
  driver: SqlDriver,
) : SuspendingTransacterImpl(driver) {
  public fun <T : Any> all(mapper: (
    id: String,
    name: String,
    creditorName: String?,
    purpose: String?,
    installmentAmountCents: Long,
    commissionCents: Long,
    extraInstallmentCents: Long?,
    extraInstallmentMonth: Long?,
    totalAmountCents: Long,
    remainingAmountCents: Long,
    accountId: String?,
    categoryId: String?,
    startEpochDay: Long,
    endEpochDay: Long,
    autoGenerateOnReminder: Boolean,
    isClosed: Boolean,
    isDeleted: Boolean,
    logoEmoji: String?,
    logoUri: String?,
    createdAtEpochMs: Long,
    updatedAtEpochMs: Long,
  ) -> T): Query<T> = Query(-1_958_914_909, arrayOf("FinancingEntity"), driver, "Financing.sq",
      "all",
      "SELECT FinancingEntity.id, FinancingEntity.name, FinancingEntity.creditorName, FinancingEntity.purpose, FinancingEntity.installmentAmountCents, FinancingEntity.commissionCents, FinancingEntity.extraInstallmentCents, FinancingEntity.extraInstallmentMonth, FinancingEntity.totalAmountCents, FinancingEntity.remainingAmountCents, FinancingEntity.accountId, FinancingEntity.categoryId, FinancingEntity.startEpochDay, FinancingEntity.endEpochDay, FinancingEntity.autoGenerateOnReminder, FinancingEntity.isClosed, FinancingEntity.isDeleted, FinancingEntity.logoEmoji, FinancingEntity.logoUri, FinancingEntity.createdAtEpochMs, FinancingEntity.updatedAtEpochMs FROM FinancingEntity WHERE isDeleted = 0") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3),
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6),
      cursor.getLong(7),
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getString(10),
      cursor.getString(11),
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getBoolean(14)!!,
      cursor.getBoolean(15)!!,
      cursor.getBoolean(16)!!,
      cursor.getString(17),
      cursor.getString(18),
      cursor.getLong(19)!!,
      cursor.getLong(20)!!
    )
  }

  public fun all(): Query<FinancingEntity> = all { id, name, creditorName, purpose,
      installmentAmountCents, commissionCents, extraInstallmentCents, extraInstallmentMonth,
      totalAmountCents, remainingAmountCents, accountId, categoryId, startEpochDay, endEpochDay,
      autoGenerateOnReminder, isClosed, isDeleted, logoEmoji, logoUri, createdAtEpochMs,
      updatedAtEpochMs ->
    FinancingEntity(
      id,
      name,
      creditorName,
      purpose,
      installmentAmountCents,
      commissionCents,
      extraInstallmentCents,
      extraInstallmentMonth,
      totalAmountCents,
      remainingAmountCents,
      accountId,
      categoryId,
      startEpochDay,
      endEpochDay,
      autoGenerateOnReminder,
      isClosed,
      isDeleted,
      logoEmoji,
      logoUri,
      createdAtEpochMs,
      updatedAtEpochMs
    )
  }

  public suspend fun upsert(
    id: String,
    name: String,
    creditorName: String?,
    purpose: String?,
    installmentAmountCents: Long,
    commissionCents: Long,
    extraInstallmentCents: Long?,
    extraInstallmentMonth: Long?,
    totalAmountCents: Long,
    remainingAmountCents: Long,
    accountId: String?,
    categoryId: String?,
    startEpochDay: Long,
    endEpochDay: Long,
    autoGenerateOnReminder: Boolean,
    isClosed: Boolean,
    isDeleted: Boolean,
    logoEmoji: String?,
    logoUri: String?,
    createdAtEpochMs: Long,
    updatedAtEpochMs: Long,
  ) {
    driver.execute(-1_736_816_915,
        """INSERT OR REPLACE INTO FinancingEntity VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)""",
        21) {
          bindString(0, id)
          bindString(1, name)
          bindString(2, creditorName)
          bindString(3, purpose)
          bindLong(4, installmentAmountCents)
          bindLong(5, commissionCents)
          bindLong(6, extraInstallmentCents)
          bindLong(7, extraInstallmentMonth)
          bindLong(8, totalAmountCents)
          bindLong(9, remainingAmountCents)
          bindString(10, accountId)
          bindString(11, categoryId)
          bindLong(12, startEpochDay)
          bindLong(13, endEpochDay)
          bindBoolean(14, autoGenerateOnReminder)
          bindBoolean(15, isClosed)
          bindBoolean(16, isDeleted)
          bindString(17, logoEmoji)
          bindString(18, logoUri)
          bindLong(19, createdAtEpochMs)
          bindLong(20, updatedAtEpochMs)
        }.await()
    notifyQueries(-1_736_816_915) { emit ->
      emit("FinancingEntity")
    }
  }

  public suspend fun setClosed(
    isClosed: Boolean,
    updatedAtEpochMs: Long,
    id: String,
  ) {
    driver.execute(1_490_700_784,
        """UPDATE FinancingEntity SET isClosed = ?, updatedAtEpochMs = ? WHERE id = ?""", 3) {
          bindBoolean(0, isClosed)
          bindLong(1, updatedAtEpochMs)
          bindString(2, id)
        }.await()
    notifyQueries(1_490_700_784) { emit ->
      emit("FinancingEntity")
    }
  }
}
